// Tokens de produto — a única camada que muda entre produtos Nolens.
//
// Cada produto tem:
//   icon   fundo escuro e saturado do squircle do ícone
//   label  tom claro e luminoso da mesma cor, usado no nome sob o ícone
//   accent escala 50–950 usada com parcimónia na UI (logo, item ativo da
//          navegação, anel de foco, no máximo um CTA por ecrã) — nunca
//          para estados, que vivem em semantic.ts
//
// O produto ativo escolhe-se com `data-product="<id>"` num elemento (em regra
// o <html>); o preset Tailwind (../../tailwind-preset.ts) transforma isto em
// variáveis CSS. Sem atributo vale `legacy`, a paleta azul do FleetOps, para
// que a introdução dos tokens não altere nada visualmente.

export type AccentScale = Record<50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950, string>

export interface NolensProduct {
  name: string
  icon: string
  label: string
  accent?: AccentScale
}

// A paleta `brand` original do FleetOps (azul).
export const legacyAccent: AccentScale = {
  50: '#eff6ff',
  100: '#dbeafe',
  200: '#bfdbfe',
  300: '#93c5fd',
  400: '#60a5fa',
  500: '#3b82f6',
  600: '#2563eb',
  700: '#1d4ed8',
  800: '#1e40af',
  900: '#1e3a8a',
  950: '#172554',
}

// Nolens Fleet — Âmbar Sinal: a cor da sinalização rodoviária e dos
// rotativos de assistência. Os ícones/nomes dos restantes produtos são
// aproximações da grelha de subprodutos e devem ser confirmados com os
// ficheiros de marca antes de serem usados.
export const products = {
  fleet: {
    name: 'Nolens Fleet',
    icon: '#6e4200',
    label: '#f5b33c',
    accent: {
      50: '#fff8eb',
      100: '#ffedc6',
      200: '#fed98a',
      300: '#fbc350',
      400: '#f5b33c',
      500: '#d98e04',
      600: '#b87300',
      700: '#925a02',
      800: '#6e4200',
      900: '#553300',
      950: '#331e00',
    },
  },
  business: { name: 'Nolens Business', icon: '#0f2a4a', label: '#9cc4ec' },
  personal: { name: 'Nolens Personal', icon: '#3d1638', label: '#c9a0d6' },
  physio: { name: 'Nolens Physio', icon: '#1f4734', label: '#4e9a6e' },
  athletics: { name: 'Nolens Athletics', icon: '#8f0000', label: '#f04545' },
} as const satisfies Record<string, NolensProduct>

export type ProductId = keyof typeof products
